// semeia-disable-reexport
import type { CPSInformations, PracticeLocation } from "parog-web/cnam/types";
import { AuthenticationContext } from "parog-web/contexts/authentication-context";

export default class MockedAuthenticationContext extends AuthenticationContext {
  get isAuthenticated(): boolean {
    return true;
  }

  cpsPracticeLocationIndice = 0;

  cpsInformations: CPSInformations = {
    practiceLocations: [
      {
        structureName: "test",
        activity: "test",
        structureId: "test",
        billingNumber: "test"
      }
    ],
    medicLastName: "lastname",
    medicFirstName: "firstname",
    medicInternalId: "id",
    medicProfessionCode: "code",
    cpxSerialNumber: "serialNumber",
    cpxValidityDate: new Date("2025-01-01")
  };

  availableLocations?: PracticeLocation[] | undefined = [
    {
      structureName: "test",
      activity: "test",
      structureId: "test",
      billingNumber: "test"
    }
  ];
}
